module.exports = __webpack_public_path__ + "img/image-slash.c617ad14.svg";